// File Metadata:
// Filename: VendorsDataGrid.js
// Version: 1.00
// Created: 2022-10-13 22:59:28
// Last Modified: 2025-04-01 17:27:27
// Authors: [Your Name]
// Description: A brief summary of what this file does

import './datatable.scss'
import { DataGrid, GridToolbar } from '@mui/x-data-grid'
import { Link } from 'react-router-dom'
import { useDeleteVendorMutation, useGetVendorsQuery } from '../api/vendorsApiSlice'
import useAuth from '../../hooks/useAuth'

const VendorsDataGrid = () => {
	const { username, isVoorman, isAdmin } = useAuth()
	const {
		data: vendors,
		isLoading,
		isSuccess,
		isError,
		error
	} = useGetVendorsQuery('vendorsList', {
		pollingInterval: 15000,
		refetchOnFocus: true,
		refetchOnMountOrArgChange: true
	})
	const [deleteVendor, { isSuccess: isDelSuccess, isError: isDelError, error: delerror }] = useDeleteVendorMutation()

	const handleDelete = async id => {
		await deleteVendor({ id })
	}

	const userColumns = [
		{
			field: 'vendorName',
			headerName: 'Vendor Name',
			flex: 2
		},
		{
			field: 'vendorNumber',
			headerName: 'Vendor Number',
			flex: 2
		},
		{
			field: 'origin',
			headerName: 'Origin',
			flex: 2
		}
	]

	const actionColumn = [
		{
			field: 'action',
			headerName: 'Action',
			flex: 2,
			renderCell: params => {
				return (
					<div className='cellAction'>
						<Link to={`/dash/vendors/${params.row.id}`} style={{ textDecoration: 'none' }}>
							<div className='viewButton'>Edit</div>
						</Link>
						{(isVoorman || isAdmin) && (
							<div className='deleteButton' onClick={() => handleDelete(params.row.id)}>
								Delete
							</div>
						)}
					</div>
				)
			}
		}
	]
	let content

	if (isLoading) content = <p>Loading...</p>

	if (isError) {
		content = <p className='errmsg'>{error?.data?.message}</p>
	}

	if (isSuccess) {
		console.log(vendors)
		const { ids, entities } = vendors
		let filteredIds
		const handleSearch = () => {
			filteredIds = ids.filter()
		}

		const tableContent = Object.values(entities)
		console.log(tableContent)

		content = (
			<div className='datatable'>
				<div className='datatableTitle'>
					Vendors List
					<Link to='/dash/vendors/new' className='link'>
						Add New
					</Link>
				</div>
				<DataGrid
					className='datagrid'
					rows={tableContent}
					columns={userColumns.concat(actionColumn)}
					pageSize={9}
					rowsPerPageOptions={[9]}
					getRowId={row => row.id}
					components={{
						Toolbar: GridToolbar
					}}
				/>
			</div>
		)
	}
	return content
}

export default VendorsDataGrid
